export default __webpack_public_path__ + "static/media/parkingrampe.c699ce04.png";